const LOCAL_DATA_TTL = 6000;

app.factory("FiveStreamApiFactory", [
  "$q",
  "config",
  "$http",
  function ($q, config, $http) {
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };

    const apiRequest = ({ endpoint, method = "GET", headers } = {}) => {
      return $http({
        method,
        url: endpoint,
        headers,
      });
    };

    const addTtlToContent = (requestData) => {
      var now = new Date();
      const storeItem = {
        content: requestData.data.data,
        expiry: now.getTime() + LOCAL_DATA_TTL,
      };

      return storeItem;
    };

    const getContentByTypeAndID = ({ siteId, id, type }) => {
      return apiRequest({
        endpoint: `${config.publicApiUrl}getShopContentByID/${siteId}/${type}/${id}`,
      });
    };

    const getPageElements = ({ siteID, page }) => {
      return apiRequest({
        endpoint: `${config.publicApiUrl}getMicrositeElementsByPage/${siteID}/${page}`,
        headers: { ...headers },
      });
    };

    const verifyCustomer = () => {
      return apiRequest({
        endpoint: `${config.fstreamAPI}verifyCustomer`,
        headers: { ...headers },
      });
    };

    const verifyCustomerOwnsContent = (contentId) => {
      return apiRequest({
        endpoint: `${config.fstreamAPI}verifyCustomerContent/${contentId}`,
        headers: { ...headers },
      });
    };

    const logoutCustomer = () => {
      return apiRequest({
        endpoint: `${config.fstreamAPI}logoutCustomer`,
        method: "DELETE",
      });
    };

    const getCustomerContent = () => {
      return apiRequest({
        endpoint: `${config.fstreamAPI}customerContentIDs`,
        headers: { ...headers },
      });
    };

    return {
      getPlaylist(siteId, id) {
        let q = $q.defer();
        getContentByTypeAndID({ siteId, id, type: "playlist" }).then(
          (response) => {
            let content = addTtlToContent(response);
            q.resolve(content);
          },
          (err) => {
            q.reject(err);
          }
        );
        return q.promise;
      },
      getPageElements(siteID, page, key) {
        let q = $q.defer();
        getPageElements({ siteID, page, key }).then(
          (response) => {
            let content = addTtlToContent(response);
            q.resolve(content);
          },
          (err) => {
            q.reject(err);
          }
        );
        return q.promise;
      },
      verifyCustomer() {
        let q = $q.defer();
        verifyCustomer().then(
          (res) => {
            q.resolve(true);
          },
          (err) => {
            q.reject(false);
          }
        );
        return q.promise;
      },
      verifyCustomerOwnsContent(contentId) {
        let q = $q.defer();
        verifyCustomerOwnsContent(contentId).then(
          (res) => {
            q.resolve(true);
          },
          (err) => {
            q.reject(false);
          }
        );
        return q.promise;
      },
      logoutCustomer() {
        let q = $q.defer();
        logoutCustomer().then(
          (res) => {
            q.resolve(true);
          },
          (err) => {
            q.reject(false);
          }
        );
        return q.promise;
      },
      getCustomerContent() {
        let q = $q.defer();
        getCustomerContent().then(
          (res) => {
            q.resolve(res);
          },
          (err) => {
            q.reject(err);
          }
        );
        return q.promise;
      },
    };
  },
]);
